module.exports = __webpack_public_path__ + "img/buy.4553c3e3.png";